// app/javascript/controllers/swiper_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Automatically runs when the element enters the DOM (initial or Turbo load)
    this.swiper = new Swiper(this.element);
  }

  disconnect() {
    // Automatically cleans up memory when the element leaves the DOM
    this.swiper.destroy();
  }
}
